import { gql } from '@apollo/client';
import { META_DATA_QUERY_FIELDS } from 'src/graphql/entities/metadata.fragments';
import { ADDRESS_FILE_FIELDS, ADDRESS_FILE_RELATIONS } from './address-file.fragments';

export const GET_ADDRESS_FILE_QUERY = gql`
  query GetAddressFile($params: QueryParams, $skipTotalRecords: Boolean = false) {
    getAddressFile(queryParams: $params) {
      records {
        ...AddressFileFields
        ...AddressFileRelations
      }
      metadata {
        ...MetaDataQueryFields
      }
    }
  }
  ${ADDRESS_FILE_FIELDS}
  ${ADDRESS_FILE_RELATIONS}
  ${META_DATA_QUERY_FIELDS}
`;

export const CREATE_ADDRESS_FILE_MUTATION = gql`
  mutation CreateAddressFile($data: AddressFileDataInput) {
    createAddressFile(data: $data) {
      ...AddressFileFields
    }
  }
  ${ADDRESS_FILE_FIELDS}
`;

export const DELETE_ADDRESS_FILE_MUTATION = gql`
  mutation DeleteAddressFile($conditions: [ConditionInput]) {
    deleteAddressFile(conditions: $conditions) {
      id
    }
  }
`;

export const UPDATE_ADDRESS_FILE_MUTATION = gql`
  mutation UpdateAddressFile($conditions: [ConditionInput], $data: AddressFileDataInput) {
    updateAddressFile(conditions: $conditions, data: $data) {
      ...AddressFileFields
    }
  }
  ${ADDRESS_FILE_FIELDS}
`;
